import styled from 'styled-components';
import Card from '@distinct-components/cards/baseCard';

export const StyledPubCard = styled(Card)`
    background: var(--panel-card);
    cursor: pointer;
    border: 0.8px solid var(--card-border);
    box-shadow: 2px 4px 11px var(--card-shadow);
    min-height: 0rem;
`;

export const PubCardGrid = styled.div`
    padding-top: 1.5rem;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 1.5em;
`;
